export default "__VITE_ASSET__BZB11pPM__"